module.exports = "https://static.zego.com/_next/static/images/hero-fleet-fa12c1c3cac394ca6cfb847513403be2.jpg";